import { render, staticRenderFns } from "./FormNaturalness.vue?vue&type=template&id=028e2bf9"
import script from "./FormNaturalness.vue?vue&type=script&lang=js"
export * from "./FormNaturalness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports